import { DynamicValueReplacer } from './DynamicValueReplacer';
import type { PluralFormatter, PluralForms } from './PluralFormatter';
import type { DynamicValues, RawDictionaryValue } from './types';

export class DictionaryValueFormatter {
  constructor(
    private options: {
      pluralFormatter?: PluralFormatter;
    } = {}
  ) {}

  format(translatedValue: RawDictionaryValue, locale: string, dynamicValues?: DynamicValues): string | undefined {
    let text: string;

    if (typeof translatedValue === 'object') {
      text = this.pluralise(dynamicValues, locale, translatedValue);
    } else {
      text = translatedValue;
    }

    if (dynamicValues) {
      text = DynamicValueReplacer.replace(text, dynamicValues);
    }

    return text;
  }

  pluralise(dynamicValues: DynamicValues | undefined, locale: string, pluralForms: PluralForms): string {
    if (this.options.pluralFormatter && locale && Array.isArray(dynamicValues)) {
      if (!dynamicValues[0]) return pluralForms.other;

      return this.options.pluralFormatter.getText({
        locale,
        quantity: parseInt(dynamicValues[0] as string, 10),
        pluralForms,
      });
    } else {
      return pluralForms.other;
    }
  }
}
